"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCustomerEmail = exports.createPaymentIntent = void 0;
const requestsSettings_1 = require("../../requestsSettings");
async function createPaymentIntent({ tip, }) {
    try {
        const response = await fetch(`${requestsSettings_1.INTERVIEW}/stripe/create-payment-intent`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tip }),
        });
        if (response.ok) {
            const result = await response.json();
            return result;
        }
    }
    catch (err) {
        console.error(`Failed to create payment intent: ${err?.data?.message}`);
        throw err;
    }
}
exports.createPaymentIntent = createPaymentIntent;
async function updateCustomerEmail({ customerId, email, }) {
    try {
        const response = await fetch(`${requestsSettings_1.INTERVIEW}/stripe/update-customer`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ customerId, email }),
        });
        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Failed to update customer: ${errorData.message}`);
        }
    }
    catch (err) {
        console.error(`Failed to update customer: ${err?.data?.message}`);
        throw err;
    }
}
exports.updateCustomerEmail = updateCustomerEmail;
//# sourceMappingURL=requests.js.map